module.exports = __webpack_public_path__ + "img/role04.cf3e6cb5.png";